"use client";

import dynamic from "next/dynamic";

const BackToTop = dynamic(() => import("@/components/back-to-top").then((mod) => mod.BackToTop), {
  ssr: false,
});

const StickyCTA = dynamic(() => import("@/components/sticky-cta").then((mod) => mod.StickyCTA), {
  ssr: false,
});

export function WebsiteClientEnhancements() {
  return (
    <>
      <BackToTop />
      <StickyCTA />
    </>
  );
}
